import React from 'react'
import classNames from 'classnames'
import './style.scss'

const FourDotLoader = ({ label = 'Loading...', color, hasBottomMargin }) => {

  const FourDotLoaderItem = () => <span className={classNames('viso-four-dot-loader__dot', color && `viso-bg-${color}`)} />

  return (
    <div className={classNames(
      'viso-four-dot-loader',
      hasBottomMargin && 'viso-four-dot-loader--bottom-margin'
    )}>
      <div
        className={classNames(
          'viso-four-dot-loader__wrapper',
          color && `viso-text-${color}`
        )}
        role='status'
        aria-live='polite'
        aria-label={label}
      >
        <span className='viso-four-dot-loader__dots' aria-hidden='true'>
          <FourDotLoaderItem />
          <FourDotLoaderItem />
          <FourDotLoaderItem />
          <FourDotLoaderItem />
        </span>
        <span className='viso-four-dot-loader__label'>{label}</span>
      </div>
    </div>
  )
}

export default FourDotLoader